import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";
import * as LayoutComponents from '../Shared/LayoutComponents.js'
import TaskManagerApp from '../TaskManagerApp/TaskManagerApp.js';
import { EventEmitter } from "events";

import '../Shared/Style.css';
import "./App.css";



const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isChangingArchiveStatus, setIsChangingArchiveStatus] = useState(false);
    const [version, setVersion] = useState(0);

    

    const [errorCurrentItem, setErrorCurrentItem] = useState(false);
    const [hasUDIUnsavedChanges, setHasUDIUnsavedChanges] = useState(false);
    const [hasProductUnsavedChanges, setHasProductUnsavedChanges] = useState(false);
    
    const [isShowingUDIUnsavedChangesWarning, setIsShowingUDIUnsavedChangesWarning] = useState(false);
    const [isShowingProductUnsavedChangesWarning, setIsShowingProductUnsavedChangesWarning] = useState(false);

    AppContext.hasUDIUnsavedChanges = hasUDIUnsavedChanges;
    AppContext.setHasUDIUnsavedChanges = setHasUDIUnsavedChanges;
    AppContext.isShowingUDIUnsavedChangesWarning = isShowingUDIUnsavedChangesWarning;
    AppContext.setIsShowingUDIUnsavedChangesWarning = setIsShowingUDIUnsavedChangesWarning;

    AppContext.hasProductUnsavedChanges = hasProductUnsavedChanges;
    AppContext.setHasProductUnsavedChanges = setHasProductUnsavedChanges;
    AppContext.isShowingProductUnsavedChangesWarning = isShowingProductUnsavedChangesWarning;
    AppContext.setIsShowingProductUnsavedChangesWarning = setIsShowingProductUnsavedChangesWarning;



    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);





    const saveCurrentItem = () => {

        setErrorCurrentItem(false);
        setIsSavingItem(true);
        setIsShowingSaveMessage(false);

        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(AppContext.currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item
                    AppContext.setCurrentItem(result);

                    // Update local original item to use when cancelling edit
                    AppContext.setOriginalItem(result);

                    setIsShowingSaveMessage(true);

                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };









    const checkResponseError = (response) => {

        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }

    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        changeTab("information");
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        setIsShowingSaveMessage(false);

        setIsEditMode(false);


    }

    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    




    // Canceling edit changes
    const cancelEdit = () => {

        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);

    }




    const toggleEditMode = () => {

        setIsEditMode(!isEditMode);

        setIsShowingSaveMessage(false);
    }



    const changeTab = (tab) => {

        
        setIsShowingSaveMessage(false);

        setVisibleDetailsTab(tab);


    }


    const closePane = () => {

        AppContext.closePane();

    }




    

    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;

            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };



    // Avoid losing unsaved changes

    useEffect(() => {

        if (!deepEqual(AppContext.currentItem, AppContext.originalItem))
            AppContext.setHasProductUnsavedChanges(true);
        else
            AppContext.setHasProductUnsavedChanges(false);

    }, [AppContext.currentItem, AppContext.originalItem]);






    const displayFieldOnly = true;

    let fullWidthPane = false;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">


                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}



                        <div className="item-details-content">

                            



                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                    <>


                                        {/* Header */}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-box-open" style={{ color: "#2b6cb0" }} />
                                                    {AppContext.singleItemTitle} Details
                                                </h2>
                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>

                                                {visibleDetailsTab == "information" ? <>

                                                    {AppContext.userRole == "Admin" ? <>

                                                    {isEditMode ?

                                                        <div id="buttom-bar" >

                                                            {/* FORMS BUTTONS */}

                                                            <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                <div className="action-button-bar-left"></div>
                                                                <div className="action-button-bar-center"></div>

                                                                <div className="action-button-bar-right">

                                                                    {!isSavingItem ? (
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={() => cancelEdit()}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                    e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                    e.currentTarget.style.borderColor = "#dee2e6";
                                                                                }}
                                                                                style={{ display: "inline-flex", alignItems: "center", padding: "6px 14px", cursor: "pointer", transition: "all 0.2s ease-in-out", color: "#5f6368", border: "1px solid #dee2e6", backgroundColor: "#ffffff", whiteSpace: "nowrap", outline: "none"
                                                                                }}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={saveCurrentItem}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <LoadingSpinnerImage />
                                                                        </>
                                                                    )}


                                                                </div>


                                                            </div>

                                                        </div>

                                                        :
                                                        <>
                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                <div style={{ flex: 1, justifyContent: "right", display: "flex", alignItems: "center", marginRight: "20px",
                                                                }}>
                                                                    {isShowingSaveMessage ?
                                                                        <span className="save-message-shown">
                                                                            Save successful!
                                                                        </span>
                                                                        : null}
                                                                </div>

                                                                <div>
                                                                    <div className="view-task-field" style={{ textAlign: "right", display: "flex", alignItems: "center", marginBottom: "0px",
                                                                    }}>
                                                                        <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                            <i className="far fa-edit pointer g-mr-8"></i>Edit {AppContext.singleItemTitle}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </>
                                                    }

                                                </>

                                                        : null}
                                                    </>

                                                : null}


                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>



                                        {/* Main content */}


                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                            {/* INFORMATION DASHBOARD */}

                                            {visibleDetailsTab == "information" ? <>

                                                {/* LEFT */}

                                                <div style={{ flex: 1, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>



                                                    <LayoutComponents.InfoBlock>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>


                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{ width: "100%", marginLeft: "40px"}}>
                                                                    <div style={{marginBottom: "20px"}}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Reference
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Name"} fieldTitle={"Name"} mandatory={true} forceIsEditing={false} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{ width: "100%", marginLeft: "40px"}}>
                                                                    <div style={{marginBottom: "20px"}}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Description
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Description"} fieldTitle={"Description"} mandatory={true} forceIsEditing={false} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{ width: "100%", marginLeft: "40px"}}>
                                                                    <div style={{marginBottom: "20px"}}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Status
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.FieldType_Compliance_Status value={AppContext.currentItem.Status} />
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                </div>

                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{ width: "100%", marginLeft: "40px"}}>
                                                                    <div style={{marginBottom: "20px"}}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Linked To
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.StandardsRelationOriginType value={AppContext.currentItem.EntityType} />
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </LayoutComponents.InfoBlock>



                                                    
                                                </div>



                                                {/* RIGHT */}

                                                <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                    
                                                    <LayoutComponents.InfoBlock>
                                                        <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                            Custom Fields
                                                        </h4>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {AppContext.enableCustomFields ?
                                                                <FieldTypes.FieldType_CustomUserFieldsView key={`custom_fields_${version}`} globalContext={AppContext} isEditing={isEditMode} />
                                                                    : null}

                                                            {AppContext.currentItem?.CustomFields?.length ? null : "No custom fields"}
                                                        </div>
                                                    </LayoutComponents.InfoBlock>


                                                </div>

                                            </> : null}







                                        </div>




                                    </>)}

                            </div>


                        </div>




                    </div>
                </div>
            
            : null}




        </>
    );
};








export default ItemDetailsPane;